function openLookTab(evt, tabName) {
  window.dispatchEvent(new Event('resize'));
   
    // Create some initial variables for use in the loops.
    var i, tabcontent, tablinks;

    // Get our actual tab wrappers and loop through them, removing any active states from ALL tabs.
    tabcontent = document.getElementsByClassName("product-tabs__tab");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    // Get our actual tab links and loop through them, removing any active states from ALL buttons.
    tablinks = document.getElementsByClassName("product-tab_link");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Set the tab clicked to show and add an active state to the button
    document.getElementById(tabName).style.display = "flex";
    evt.currentTarget.className += " active";
    
}

// FAQs accordion functionality
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}



// Mobile tab content accordion functionality
var acc = document.getElementsByClassName("mobile-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }

    if(this.hasAttribute("data-ing")){
      flkty.resize();
    }

  });
}

var elem = document.querySelector('.mobile-slider');
var flkty = new Flickity( elem, {
  // options
  cellAlign: 'left',
  contain: true,
  imagesLoaded: true,
  resize: true,
  setGallerySize: false,
  pageDots: false,
  prevNextButtons: false
});


document.getElementsByClassName('prev-flick')[0].addEventListener("click", function() {
  flkty.previous(false, false);
});
document.getElementsByClassName('next-flick')[0].addEventListener("click", function() {
  flkty.next(false, false);
});

const cbox = document.querySelectorAll(".ing");

 for (let i = 0; i < cbox.length; i++) {
     cbox[i].addEventListener("click", function() {
      const flkty = Flickity.data('.product-tabs-ingredients__list');
      flkty.resize();
     });
 }